module.exports = __webpack_public_path__ + "static/media/Eunice-foto-circular.4b898901.png";